import {FocusEvent} from 'react';

import {OptionSimple} from '@yandex-lego/components/Select';

export function toOptions(values: number[]): OptionSimple[] {
    return values.map(value => ({value: value.toString(), content: value.toString()}));
}

export function selectOnFocus(e: FocusEvent<HTMLInputElement>) {
    e.target?.select();
}
